export default (actionBase = "") => ({
  request: `${actionBase}_REQUEST`,
  success: `${actionBase}_SUCCESS`,
  failure: `${actionBase}_FAILURE`,
});
